import script from "./productScale.vue?vue&type=script&lang=ts&setup=true"
export * from "./productScale.vue?vue&type=script&lang=ts&setup=true"

import "./productScale.vue?vue&type=style&index=0&id=7e83fe57&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e83fe57"]])

export default __exports__